/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { isSubscriptionUnpaid } from '@app/domain/nebula';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NebulaSubscriptionInfo, NebulaSubscriptionStatus } from '@shared/types/nebula';

export const nebulaSubscription = createFeatureSelector<AppState['nebulaSubscription']>('nebulaSubscription');
export const nebulaPlansClusters = createSelector(nebulaSubscription, (subscription) =>
  subscription && subscription.status !== NebulaSubscriptionStatus.NOT_PURCHASED ? subscription.clusters : null,
);
export const hasNebulaPlansClusters = createSelector(nebulaPlansClusters, (clusters) => !!clusters?.length);

export const nebulaClusterTerminationTime = createSelector(nebulaSubscription, (subscription) =>
  subscription && subscription.status === NebulaSubscriptionStatus.UNPAID ? subscription.clusterTerminationTime : null,
);

export const subscriptionAvailableCredit = createSelector(
  nebulaSubscription,
  (subscription: NebulaSubscriptionInfo | null) => (subscription ? subscription.availableCredit : null),
);

export const subscriptionBalanceExhaustionTime = createSelector(
  nebulaSubscription,
  (subscription: NebulaSubscriptionInfo | null) =>
    subscription && subscription.status === NebulaSubscriptionStatus.ACTIVE ? subscription.balanceExhaustionTime : null,
);

export const isNebulaSubscriptionUnpaidSelector = createSelector(nebulaSubscription, isSubscriptionUnpaid);
